<script>
import {
  SimpleBar
} from "simplebar-vue3";

import Swal from "sweetalert2";
import i18n from "../i18n";
import { AbilityBuilder, Ability } from '@casl/ability';
import { ABILITY_TOKEN } from '@casl/vue';
import { fetchOUAccess } from "@/helpers/abilities.js";
import { fetchMenus } from "@/helpers/menuApi.js";
import axios from "axios";
/**
 * Nav-bar Component
 */
export default {
  inject: {
    $ability: { from: ABILITY_TOKEN }
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      myVar: 1,
      searchQuery: '',
      showDropdown: false,
      otherDocuments: [],
      searchLoading: false,
      activeIndex: -1,
      docSearchTimer: null,
      recentSearches: JSON.parse(localStorage.getItem('recentMenuSearches') || '[]'),
      onDocClickHandler: null,
      onGlobalKeyHandler: null,
    }
  },
  components: {
    SimpleBar,
  },

  methods: {
    getFirstRoute(menu) {
      if (menu.children.length > 0) {
        if (menu.children[0].subchildren.length > 0) {
          if (menu.children[0].subchildren[0].grandchildren.length > 0) {
            return menu.children[0].subchildren[0].grandchildren[0];
          } else {
            return menu.children[0].subchildren[0];
          }
        } else {
          return menu.children[0];
        }
      } else {
        return menu;
      }
    },
    getLandingRoute() {
      let menus = this.$store.state.menus;

      if (menus.length > 0) {
        return this.getFirstRoute(menus[0]).url;
      } else {
        return '/error/no-permission';
      }
    },
    handleOUselect(event) {
      Swal.fire({
        title: "Do you want to proceed?",
        text: "You will be redirected to home page. Any unsaved changes that you made will be discarded.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes!",
      }).then(async (confirm) => {
        if (confirm.isConfirmed) { 
          //if confirmed to delete, then delete all selected rows
          this.$store.commit('setActiveOU', event.target.value);

          await fetchMenus();
          await this.updateAbility();
          this.getOUDetails();

          this.$router.push({ path: this.getLandingRoute() });
        }
        this.loadOU();
      });
    },
    async updateAbility() {
      const { can, rules } = new AbilityBuilder(Ability);
      const roles = localStorage.getItem("userRoles") ? JSON.parse(localStorage.getItem("userRoles")) : [];
      if (roles.includes(1)) {
        can('manage', 'all');
      } else {
        const url = `${process.env.VUE_APP_AUTHDOMAIN}/api/v1/settings/company-permissions`;
        let permissions = [];
        await axios.post(url, { roles: roles, ou_code: this.ouCode })
          .then(result => {
            if (result.data.data) {
              permissions = result.data.data
            }
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            if (permissions.length > 0) {
              permissions.forEach(item => {
                can(item.permission.code, item.menu.menu_name);
              });
            }
          });
      }
      this.$store.commit('setRules', rules);
      this.$ability.update(rules);
    },

    getLogoUrl(logo) {
      if (!logo) return '';
      if (logo.startsWith('http') || logo.startsWith('data:')) {
        return logo;
      }
      return `${process.env.VUE_APP_AUTHDOMAIN}/storage/${logo}`;
    },

    async getOUDetails() {
      const url = `${process.env.VUE_APP_AUTHDOMAIN}/api/v1/ou/${this.ouCode}`;
      await axios.get(url)
        .then(result => {
          if (result.data.data) {
            const logo = this.getLogoUrl(result.data.data.ou_logo)
            localStorage.setItem('ouLogo', logo);
            this.$emit('ouSelected', logo);
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {

        });
    },
    loadOU() {
      if (localStorage.getItem('ouAccess') == null || localStorage.getItem('ouAccess').length === 0) {
        fetchOUAccess();
      }
      else {
        this.$store.commit('getOUAccess');
      }
    },
    loadActiveOU() {
      this.$store.commit('getActiveOU');
    },
    toggleHamburgerMenu() {
      var windowSize = document.documentElement.clientWidth;
      let layoutType = document.documentElement.getAttribute("data-layout");
      let visiblilityType = document.documentElement.getAttribute("data-sidebar-visibility");
      if (windowSize > 767)
        document.querySelector(".hamburger-icon").classList.toggle("open");

      //For collapse horizontal menu
      if (
        document.documentElement.getAttribute("data-layout") === "horizontal"
      ) {
        document.body.classList.contains("menu") ?
          document.body.classList.remove("menu") :
          document.body.classList.add("menu");
      }

      //For collapse vertical menu

      if (visiblilityType === "show" && (layoutType === "vertical" || layoutType === "semibox")) {
        if (windowSize < 1025 && windowSize > 767) {
          document.body.classList.remove("vertical-sidebar-enable");
          document.documentElement.getAttribute("data-sidebar-size") == "sm" ?
            document.documentElement.setAttribute("data-sidebar-size", "") :
            document.documentElement.setAttribute("data-sidebar-size", "sm");
        } else if (windowSize > 1025) {
          document.body.classList.remove("vertical-sidebar-enable");
          document.documentElement.getAttribute("data-sidebar-size") == "lg" ?
            document.documentElement.setAttribute("data-sidebar-size", "sm") :
            document.documentElement.setAttribute("data-sidebar-size", "lg");
        } else if (windowSize <= 767) {
          document.body.classList.add("vertical-sidebar-enable");
          document.documentElement.setAttribute("data-sidebar-size", "lg");
        }
      }

      //Two column menu
      if (document.documentElement.getAttribute("data-layout") == "twocolumn") {
        document.body.classList.contains("twocolumn-panel") ?
          document.body.classList.remove("twocolumn-panel") :
          document.body.classList.add("twocolumn-panel");
      }
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      document.getElementById("header-lang-img").setAttribute("src", flag);
      i18n.global.locale = locale;
    },
    toggleDarkMode() {
      if (document.documentElement.getAttribute("data-layout-mode") == "dark") {
        document.documentElement.setAttribute("data-layout-mode", "light");
      } else {
        document.documentElement.setAttribute("data-layout-mode", "dark");
      }
    },
    initTopbarComponents() {

      // notification messages
      if (document.getElementsByClassName("notification-check")) {
        Array.from(document.querySelectorAll(".notification-check input")).forEach(function (element) {
          element.addEventListener("click", function (el) {
            el.target.closest(".notification-item").classList.toggle("active");
          });
        });
      }
    },

    onSearchFocus() {
      this.showDropdown = true;
    },

    clearSearch() {
      this.searchQuery = '';
      this.otherDocuments = [];
      this.activeIndex = -1;
      this.$refs.searchInput?.focus();
    },

    async fetchDocuments(q) {
      const userId = localStorage.getItem('userid');
      const ou = localStorage.getItem('activeOU');
      const url = `${process.env.VUE_APP_AUTHDOMAIN}/api/v1/menu-search`;
      try {
        const result = await axios.get(url, { params: { query: q, user_id: userId, ou: ou } });
        const docs = result?.data?.otherDocumentsData;
        this.otherDocuments = Array.isArray(docs) && docs.length > 0 ? docs : [];
      } catch (error) {
        console.log(error);
        this.otherDocuments = [];
      } finally {
        this.searchLoading = false;
      }
    },

    openResult(item) {
      if (!item) return;
      const href = this.resultHref(item);
      if (!href) return;
      if (item.kind === 'menu') this.addRecent(item.data);
      this.showDropdown = false;
      this.searchQuery = '';
      this.otherDocuments = [];
      this.activeIndex = -1;
      if (/^https?:\/\//i.test(href)) {
        window.location.href = href;
      } else {
        this.$router.push(href).catch(() => { });
      }
    },

    onSearchKeydown(e) {
      const len = this.flatResults.length;
      if (e.key === 'ArrowDown') {
        if (!this.showDropdown) this.showDropdown = true;
        if (len === 0) return;
        e.preventDefault();
        this.activeIndex = (this.activeIndex + 1) % len;
        this.$nextTick(this.scrollActiveIntoView);
      } else if (e.key === 'ArrowUp') {
        if (len === 0) return;
        e.preventDefault();
        this.activeIndex = this.activeIndex <= 0 ? len - 1 : this.activeIndex - 1;
        this.$nextTick(this.scrollActiveIntoView);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (this.activeIndex >= 0 && this.activeIndex < len) {
          this.openResult(this.flatResults[this.activeIndex]);
        } else if (len > 0) {
          this.openResult(this.flatResults[0]);
        }
      } else if (e.key === 'Escape') {
        e.preventDefault();
        if (this.searchQuery) {
          this.clearSearch();
        } else {
          this.showDropdown = false;
          this.$refs.searchInput?.blur();
        }
      }
    },

    scrollActiveIntoView() {
      const el = this.$refs.searchWrapper?.querySelector('.menu-search-item.active');
      if (el && typeof el.scrollIntoView === 'function') {
        el.scrollIntoView({ block: 'nearest' });
      }
    },

    addRecent(menu) {
      if (!menu?.url) return;
      const entry = {
        menu_name: menu.menu_name,
        url: menu.url,
        icon: menu.icon,
        path: menu.path || [menu.menu_name],
      };
      const filtered = this.recentSearches.filter(r => r.url !== entry.url);
      filtered.unshift(entry);
      this.recentSearches = filtered.slice(0, 6);
      localStorage.setItem('recentMenuSearches', JSON.stringify(this.recentSearches));
    },

    clearRecent() {
      this.recentSearches = [];
      localStorage.removeItem('recentMenuSearches');
    },

    sectionOf(item) {
      if (!item) return '';
      return item.kind === 'menu' ? 'Menu' : (item.data?.doc_type || 'Document');
    },

    needsHeader(idx) {
      const cur = this.flatResults[idx];
      if (!cur) return false;
      if (idx === 0) return true;
      return this.sectionOf(this.flatResults[idx - 1]) !== this.sectionOf(cur);
    },

    resultHref(item) {
      return item?.kind === 'menu' ? item.data?.url : item?.data?.generated_url;
    },

    resultIcon(item) {
      if (item?.kind === 'menu') return item.data?.icon || 'ri-menu-line';
      return 'ri-file-text-line';
    },

    resultTitle(item) {
      return item?.kind === 'menu' ? (item.data?.menu_name || '') : (item?.data?.doc_no || '');
    },

    resultSubtitle(item) {
      if (item?.kind === 'menu') {
        const path = item.data?.path || [];
        return path.length > 1 ? path.slice(0, -1).join(' › ') : '';
      }
      return item?.data?.doc_type || '';
    },

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text == null ? '' : String(text);
      return div.innerHTML;
    },

    highlight(text) {
      const safe = this.escapeHtml(text);
      const q = this.searchQuery.trim();
      if (!q) return safe;
      const escaped = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return safe.replace(new RegExp(`(${escaped})`, 'ig'), '<mark class="menu-search-mark">$1</mark>');
    },

    handleOutsideClick(e) {
      const wrap = this.$refs.searchWrapper;
      if (wrap && !wrap.contains(e.target)) this.showDropdown = false;
    },

    handleGlobalShortcut(e) {
      if ((e.ctrlKey || e.metaKey) && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault();
        this.$refs.searchInput?.focus();
        this.$refs.searchInput?.select();
        this.showDropdown = true;
      }
    },
  },
  computed: {
    ouAccess() {
      return this.$store.state.ouAccess
    },
    ouCode() {
      return this.$store.state.activeOU
    },
    rules() {
      return this.$store.state.rules
    },
    flatMenus() {
      const out = [];
      const walk = (items, trail) => {
        for (const m of items || []) {
          if (!m) continue;
          const path = [...trail, m.menu_name];
          const hasKids = !!(m.children?.length || m.subchildren?.length || m.grandchildren?.length);
          out.push({
            menu_name: m.menu_name,
            url: m.url,
            icon: m.icon,
            path,
            isLeaf: !hasKids,
          });
          if (m.children?.length) walk(m.children, path);
          if (m.subchildren?.length) walk(m.subchildren, path);
          if (m.grandchildren?.length) walk(m.grandchildren, path);
        }
      };
      walk(this.$store.state.menus || [], []);
      return out;
    },
    filteredMenus() {
      const q = this.searchQuery.trim().toLowerCase();
      if (!q) return [];
      const results = [];
      for (const m of this.flatMenus) {
        if (!m.url) continue;
        const name = (m.menu_name || '').toLowerCase();
        const trail = m.path.join(' › ').toLowerCase();
        let score = 0;
        if (name === q) score = 100;
        else if (name.startsWith(q)) score = 80;
        else if (name.includes(q)) score = 60;
        else if (trail.includes(q)) score = 30;
        if (score === 0) continue;
        if (m.isLeaf) score += 10;
        results.push({ ...m, score });
      }
      results.sort((a, b) => b.score - a.score || a.menu_name.localeCompare(b.menu_name));
      return results.slice(0, 30);
    },
    flatResults() {
      const items = [];
      this.filteredMenus.forEach(m => items.push({ kind: 'menu', data: m }));
      (this.otherDocuments || []).forEach(group => {
        (group || []).forEach(d => items.push({ kind: 'doc', data: d }));
      });
      return items;
    },
  },

  watch: {
    searchQuery(val) {
      this.activeIndex = this.filteredMenus.length > 0 ? 0 : -1;
      if (this.docSearchTimer) clearTimeout(this.docSearchTimer);
      const q = (val || '').trim();
      if (q.length >= 2) {
        this.searchLoading = true;
        this.docSearchTimer = setTimeout(() => this.fetchDocuments(q), 300);
      } else {
        this.otherDocuments = [];
        this.searchLoading = false;
      }
    },
  },

  created() {

  },
  mounted() {
    this.loadOU();
    this.loadActiveOU();

    document.addEventListener("scroll", function () {
      var pageTopbar = document.getElementById("page-topbar");
      if (pageTopbar) {
        document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50 ? pageTopbar.classList.add(
          "topbar-shadow") : pageTopbar.classList.remove("topbar-shadow");
      }
    });
    if (document.getElementById("topnav-hamburger-icon"))
      document
        .getElementById("topnav-hamburger-icon")
        .addEventListener("click", this.toggleHamburgerMenu);

    this.initTopbarComponents();

    this.onDocClickHandler = this.handleOutsideClick;
    this.onGlobalKeyHandler = this.handleGlobalShortcut;
    document.addEventListener('click', this.onDocClickHandler);
    document.addEventListener('keydown', this.onGlobalKeyHandler);
  },
  beforeUnmount() {
    if (this.onDocClickHandler) document.removeEventListener('click', this.onDocClickHandler);
    if (this.onGlobalKeyHandler) document.removeEventListener('keydown', this.onGlobalKeyHandler);
    if (this.docSearchTimer) clearTimeout(this.docSearchTimer);
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="layout-width">
      <div class="navbar-header bg-success text-light">
        <div class="d-flex">
          <!-- LOGO -->
          <div class="navbar-brand-box horizontal-logo">
            <router-link to="/" class="logo logo-dark">
              <span class="logo-sm">
                <img src="@/assets/images/logo-sm.png" alt="" height="22" />
              </span>
              <span class="logo-lg">
                
              </span>
            </router-link>

            <router-link to="/" class="logo logo-light">
              <span class="logo-sm">
                <img src="@/assets/images/logo-sm.png" alt="" height="22" />
              </span>
              <span class="logo-lg">
                <!-- <img src="@/assets/images/logo-light.png" alt="" height="17" /> -->
                
              </span>
            </router-link>
          </div>

          <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
            id="topnav-hamburger-icon">
            <span class="hamburger-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>

          <!-- App Search-->
          <div class="app-search d-none d-md-block" ref="searchWrapper">
            <div class="position-relative">
              <input
                ref="searchInput"
                type="text"
                class="form-control bg-white text-dark menu-search-input"
                style="color: black!important;"
                placeholder="Search menus & documents…  (Ctrl + K)"
                autocomplete="off"
                v-model="searchQuery"
                @focus="onSearchFocus"
                @keydown="onSearchKeydown"
                role="combobox"
                aria-autocomplete="list"
                aria-controls="menu-search-dropdown"
                :aria-expanded="showDropdown ? 'true' : 'false'"
              />
              <span class="mdi mdi-magnify search-widget-icon text-dark"></span>
              <span
                v-if="searchQuery"
                class="mdi mdi-close-circle search-widget-icon search-widget-icon-close"
                style="cursor: pointer;"
                @click="clearSearch"
                title="Clear"
              ></span>
            </div>
            <div
              v-show="showDropdown"
              id="menu-search-dropdown"
              class="dropdown-menu dropdown-menu-lg show menu-search-dropdown"
              role="listbox"
            >
              <SimpleBar data-simplebar style="max-height: 380px">

                <!-- Empty input: show recent searches -->
                <template v-if="!searchQuery.trim()">
                  <div class="dropdown-header d-flex justify-content-between align-items-center">
                    <h6 class="text-overflow text-muted mb-0 text-uppercase fw-semibold">Recent</h6>
                    <a
                      v-if="recentSearches.length"
                      href="#"
                      class="text-muted small text-decoration-none"
                      @click.prevent="clearRecent"
                    >Clear</a>
                  </div>
                  <div v-if="!recentSearches.length" class="px-3 py-3 text-muted small text-center">
                    <i class="mdi mdi-magnify fs-24 d-block mb-1"></i>
                    Start typing to search any menu or document.<br />
                    <span class="text-muted">Tip: press <kbd>Ctrl</kbd> + <kbd>K</kbd> anywhere to focus search.</span>
                  </div>
                  <b-link
                    v-for="(r, ri) in recentSearches"
                    :key="'recent-' + ri"
                    :href="r.url"
                    class="dropdown-item menu-search-item d-flex align-items-center"
                    @click.prevent="openResult({ kind: 'menu', data: r })"
                  >
                    <i :class="r.icon || 'mdi mdi-history'" class="align-middle fs-18 text-muted me-2"></i>
                    <span class="flex-grow-1 text-truncate">
                      <span class="d-block text-truncate">{{ r.menu_name }}</span>
                      <small v-if="r.path && r.path.length > 1" class="text-muted text-truncate d-block">
                        {{ r.path.slice(0, -1).join(' › ') }}
                      </small>
                    </span>
                    <i class="mdi mdi-history text-muted ms-2"></i>
                  </b-link>
                </template>

                <!-- Active search results -->
                <template v-else>
                  <template v-for="(item, idx) in flatResults" :key="'res-' + idx">
                    <div v-if="needsHeader(idx)" class="dropdown-header d-flex align-items-center">
                      <h6 class="text-overflow text-muted mb-0 text-uppercase fw-semibold">
                        {{ sectionOf(item) }}
                      </h6>
                    </div>
                    <b-link
                      :href="resultHref(item)"
                      class="dropdown-item menu-search-item d-flex align-items-center"
                      :class="{ 'active': activeIndex === idx }"
                      @click.prevent="openResult(item)"
                      @mouseenter="activeIndex = idx"
                      role="option"
                      :aria-selected="activeIndex === idx ? 'true' : 'false'"
                    >
                      <i :class="resultIcon(item)" class="align-middle fs-18 text-muted me-2"></i>
                      <span class="flex-grow-1 text-truncate">
                        <span class="d-block text-truncate" v-html="highlight(resultTitle(item))"></span>
                        <small
                          v-if="resultSubtitle(item)"
                          class="text-muted text-truncate d-block"
                          v-html="highlight(resultSubtitle(item))"
                        ></small>
                      </span>
                      <i class="mdi mdi-arrow-top-left text-muted ms-2"></i>
                    </b-link>
                  </template>

                  <div v-if="searchLoading" class="px-3 py-2 text-muted small d-flex align-items-center">
                    <b-spinner small variant="success" class="me-2"></b-spinner>
                    Searching documents…
                  </div>

                  <div
                    v-if="!searchLoading && flatResults.length === 0"
                    class="px-3 py-4 text-center"
                  >
                    <i class="mdi mdi-magnify-close fs-24 text-muted d-block mb-1"></i>
                    <div class="text-muted">No results for "<strong>{{ searchQuery }}</strong>"</div>
                  </div>
                </template>

                <div class="menu-search-footer px-3 py-2 border-top small text-muted d-flex justify-content-between">
                  <span><kbd>↑</kbd> <kbd>↓</kbd> navigate</span>
                  <span><kbd>Enter</kbd> open</span>
                  <span><kbd>Esc</kbd> close</span>
                </div>
              </SimpleBar>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-center">
          <div class="dropdown d-md-none topbar-head-dropdown header-item">
            <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
              id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="bx bx-search fs-22"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
              aria-labelledby="page-header-search-dropdown">
              <form class="p-3">
                <div class="form-group m-0">
                  <div class="input-group">
                    <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username" />
                    <b-button variant="primary" type="submit">
                      <i class="mdi mdi-magnify"></i>
                    </b-button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="ms-1 header-item d-sm-flex">
            <select class="form-select w-xl" :readonly="ouAccess.length <= 1" @change="handleOUselect" v-model="ouCode">
              <option v-for="( row, index ) in  ouAccess " :key="index" :value="row.ou_code">{{ row.ou_name }}</option>
            </select>
          </div>
          <div class="ms-1 header-item d-none d-sm-flex">
            <b-button type="button" variant="ghost-secondary" class="text-light btn-icon btn-topbar rounded-circle"
              data-toggle="fullscreen" @click="initFullScreen">
              <i class="bx bx-fullscreen fs-22"></i>
            </b-button>
          </div>

          <div class="ms-1 header-item d-none d-sm-flex">
            <b-button type="button" variant="ghost-secondary"
              class="text-light btn-icon btn-topbar rounded-circle light-dark-mode" @click="toggleDarkMode">
              <i class="bx bx-moon fs-22"></i>
            </b-button>
          </div>

          <div class="dropdown ms-sm-3 header-item topbar-user bg-success bg-gradient">
            <button type="button" class="btn" id="page-header-user-dropdown" data-bs-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <span class="d-flex align-items-center">
                <img class="rounded-circle header-profile-user" src="@/assets/images/users/user-dummy-img.jpg"
                  alt="Header Avatar" />
                <span class="text-start ms-xl-2">
                  <span class=" d-none d-xl-inline-block ms-1 fw-medium user-name-text">{{ user.name }}</span>
                  <!-- <span class="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{{ user.email }}</span> -->
                </span>
              </span>
            </button>
            <div class="dropdown-menu dropdown-menu-end">
              <!-- <h6 class="dropdown-header">Welcome Anna!</h6> -->
              <router-link class="dropdown-item" to="/user/profile/"><i
                  class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                <span class="align-middle">Profile</span>
              </router-link>

              <div class="dropdown-divider"></div>
              <b-link class="dropdown-item" href="/logout"><i
                  class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                <span class="align-middle" data-key="t-logout">Logout</span>
              </b-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped>
.menu-search-input {
  border-radius: 0.5rem;
  padding-left: 2.25rem;
  transition: box-shadow 0.15s ease, background-color 0.15s ease;
}
.menu-search-input:focus {
  background-color: #fff !important;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.35);
}

.menu-search-dropdown {
  width: 480px;
  max-width: calc(100vw - 2rem);
  padding: 0.25rem 0;
  border: 0;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.06);
  border-radius: 0.5rem;
  overflow: hidden;
}

.menu-search-dropdown .dropdown-header {
  padding: 0.5rem 1rem 0.25rem;
  background: #f8f9fb;
  position: sticky;
  top: 0;
  z-index: 1;
}

.menu-search-item {
  padding: 0.5rem 1rem;
  border-left: 3px solid transparent;
  cursor: pointer;
  transition: background-color 0.1s ease, border-color 0.1s ease;
  white-space: normal;
}
.menu-search-item:hover,
.menu-search-item.active {
  background-color: rgba(13, 110, 253, 0.06);
  border-left-color: #198754;
  color: inherit;
}
.menu-search-item.active small,
.menu-search-item:hover small {
  color: #495057 !important;
}

:deep(.menu-search-mark) {
  background-color: #fff3cd;
  color: inherit;
  padding: 0 1px;
  border-radius: 2px;
  font-weight: 600;
}

.menu-search-footer kbd {
  background-color: #f1f3f5;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 1px 5px;
  font-size: 0.7rem;
  color: #495057;
}
</style>